import { ofType } from "redux-observable";
import { merge, of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { setFloatSpinner } from "../../../App/module/actions";
import {
  actionTypes,
  fetchAttachmentTabsSuccess,
  fetchAttachmentTabsFailure,
  fetchAttachmentsSuccess,
  fetchAttachmentsFailure,
  fetchDownloadAttachmentSuccess,
  fetchDownloadAttachmentFailure,
  fetchDeleteAttachmentSuccess,
  fetchDeleteAttachmentFailure,
} from "./actions";
import { IAttachmentPanelTab } from "./constants";
import {
  fetchAllAttachmentsInASection,
  fetchTabSections,
  fetchDownloadAttachment,
  fetchDeleteAttachment,
} from "./services";

export const fetchAttachmentTabsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.PANEL_TAB_REQUEST),
    mergeMap(() =>
      fetchTabSections().pipe(
        map((response: IAttachmentPanelTab[]) =>
          fetchAttachmentTabsSuccess(response)
        ),
        catchError((error: any) => of(fetchAttachmentTabsFailure(error)))
      )
    )
  );

export const fetchAttachmentListEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.PANEL_TAB_ATTACHMENT_REQUEST),
    mergeMap((action: any) =>
      fetchAllAttachmentsInASection(action.payload).pipe(
        map((response: any[]) => fetchAttachmentsSuccess(response)),
        catchError((error: any) => of(fetchAttachmentsFailure(error)))
      )
    )
  );

export const fetchDownloadAttachmentEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DOWNLOAD_ATTACHMENT_REQUEST),
    mergeMap((action: any) =>
      fetchDownloadAttachment(action.payload.id).pipe(
        mergeMap((response: any) =>
          merge(
            of(
              fetchDownloadAttachmentSuccess({
                response: response,
                request: action.payload,
              })
            ),
            of(setFloatSpinner(false))
          )
        ),
        catchError((error: any) =>
          merge(
            of(fetchDownloadAttachmentFailure(error)),
            of(setFloatSpinner(false))
          )
        )
      )
    )
  );

export const fetchDeleteAttachmentEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_ATTACHMENT_REQUEST),
    mergeMap((action: any) =>
      fetchDeleteAttachment(action.payload).pipe(
        map((response: any) => fetchDeleteAttachmentSuccess(response)),
        catchError((error: any) => of(fetchDeleteAttachmentFailure(error)))
      )
    )
  );

export default [
  fetchAttachmentTabsEpic,
  fetchAttachmentListEpic,
  fetchDownloadAttachmentEpic,
  fetchDeleteAttachmentEpic,
];
